// @flow

import type { BasicProps, PropsSchema } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'
import $ from 'jquery'

type Props = BasicProps & {
  style: { [string]: string },
  swiperParam: string,
  children: React.ChildrenArray<React.Node>
};

@computeData({ includeVisible: false })
export default class SwiperComp extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style'
    }
  ];

  constructor (props: Props) {
    super(props)
    this.swiperPromise = Promise.all([
      import('swiper/dist/js/swiper'),
      import('swiper/dist/css/swiper.min.css')
    ]).then(([Swiper]) => {
      return Swiper
    })
  }

  swiperPromise: Promise<*>;

  componentDidMount () {
    this.swiperPromise.then(Swiper => {
      $(this.refs.swiperWrapper)
        .children()
        .addClass('swiper-slide')
      try {
        // eslint-disable-next-line
        new Swiper(this.refs.swiper, {
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          direction: 'vertical',
          slidesPerView: 'auto',
          loop: true,
          speed: 500
        })
      } catch (e) {
        console.log(e)
      }
    })
  }

  render () {
    const { id, style, children } = this.props
    return (
      <div id={id} style={style} className='swiper-container' ref='swiper'>
        <div className='swiper-wrapper' ref='swiperWrapper'>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/app/Marquee.js